<template>
	<div class="editor-canvas" @click.self="$emit('deselect')">
		<div class="editor-canvas__email-wrapper" :style="wrapperStyle">
			<draggable
				:list="blocks"
				:group="{ name: 'blocks', put: true, pull: true }"
				ghost-class="editor-canvas__ghost"
				drag-class="editor-canvas__drag"
				:animation="200"
				class="editor-canvas__drop-zone"
				@change="$emit('change')">

				<email-block
					v-for="(block, index) in blocks"
					:key="block.id"
					:block="block"
					:selected="selectedBlockId === block.id"
					:selected-block-id="selectedBlockId"
					:show-borders="showBorders"
					:template-variables="templateVariables"
					:is-first="index === 0"
					:is-last="index === blocks.length - 1"
					@select="$emit('select', $event)"
					@move-up="$emit('move-up', $event)"
					@move-down="$emit('move-down', $event)"
					@duplicate="$emit('duplicate', $event)"
					@delete="$emit('delete', $event)"
					@ai="$emit('ai', $event)"
					@content-change="$emit('content-change', $event)"
					@settings-change="$emit('settings-change', $event)"
					@child-change="$emit('child-change')">
				</email-block>

				<!-- Empty state (inside draggable so it acts as drop zone) -->
				<div v-if="!blocks.length" slot="header" class="editor-canvas__empty">
					<p class="body-1 grey--text text--darken-2 mb-1">Parti da un modello</p>
					<p class="caption grey--text mb-4">La struttura di una mail tipo, da riempire a mano o con l'assistente</p>
					<div class="editor-canvas__models">
						<button v-for="model in models" :key="model.key" type="button" class="editor-canvas__model" @click="$emit('model', model.key)">
							<v-icon large color="grey darken-2">{{ model.icon }}</v-icon>
							<span class="editor-canvas__model-name">{{ model.label }}</span>
							<span class="editor-canvas__model-desc">{{ model.description }}</span>
						</button>
					</div>
					<p class="caption grey--text mt-5 mb-0">…oppure aggiungi un blocco dalla colonna a sinistra: basta un clic, o trascinalo qui</p>
				</div>
			</draggable>
		</div>
	</div>
</template>

<script>
import draggable from 'vuedraggable'
import EmailBlock from './EmailBlock'
import { emailModels } from './emailModels'

export default {
	name: 'editor-canvas',

	components: {
		draggable,
		'email-block': EmailBlock
	},

	props: {
		blocks: { type: Array, required: true },
		selectedBlockId: { type: String, default: null },
		showBorders: { type: Boolean, default: false },
		zoom: { type: Number, default: 100 },
		templateVariables: { type: Array, default: function() { return [] } }
	},

	data: function() {
		return { models: emailModels }
	},

	computed: {
		// `zoom` e non `transform: scale()`: lo scale non cambia lo spazio occupato, quindi
		// sotto la mail resterebbe il vuoto della dimensione originale e lo scorrimento sballa
		wrapperStyle: function() {
			return this.zoom === 100 ? {} : { zoom: this.zoom / 100 }
		}
	}
}
</script>

<style scoped>
.editor-canvas {
	flex: 1;
	overflow-y: auto;
	background: #eeeeee;
	padding: 24px;
	display: flex;
	justify-content: center;
}

.editor-canvas__email-wrapper {
	width: 600px;
	min-height: 500px;
	background: #ffffff;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
	align-self: flex-start;
}

.editor-canvas__drop-zone {
	min-height: 500px;
}

.editor-canvas__empty {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-height: 400px;
	border: 2px dashed #e0e0e0;
	margin: 24px;
	border-radius: 8px;
	padding: 24px;
	text-align: center;
}

.editor-canvas__models {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 12px;
	width: 100%;
}

.editor-canvas__model {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 16px 10px;
	border: 1px solid #e0e0e0;
	border-radius: 8px;
	background: #fafafa;
	cursor: pointer;
	transition: border-color 0.15s, background 0.15s;
}

.editor-canvas__model:hover {
	border-color: #9e9e9e;
	background: #fff;
}

.editor-canvas__model-name {
	margin-top: 8px;
	font-size: 14px;
	font-weight: 600;
	color: rgba(0, 0, 0, 0.87);
}

.editor-canvas__model-desc {
	margin-top: 4px;
	font-size: 12px;
	line-height: 16px;
	color: rgba(0, 0, 0, 0.6);
}

.editor-canvas__ghost {
	opacity: 0.4;
	background: #e3f2fd;
	outline: 2px dashed #1976d2;
}

.editor-canvas__drag {
	opacity: 0.8;
}
</style>
